import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createRoleAPI,
  getRolesAPI,
  getRoleByIdAPI,
  updateRoleAPI,
  deleteRoleAPI,
} from "../../api/roles";

//  Create New Role

export const createRole = createAsyncThunk("roles/create", async (payload, { rejectWithValue }) => {
  try {
    const res = await createRoleAPI(payload);
    return res.data;
  } catch (err) {
    console.log("createRole error ======>", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

//  Get all roles

export const getRoles = createAsyncThunk("roles/getAll", async (payload, { rejectWithValue }) => {
  try {
    const res = await getRolesAPI(payload);
    return res.data;
  } catch (err) {
    console.log("getRoles error ======>", err);
    return rejectWithValue(err.response?.data || err.message);
  }
});

//  Get single role

export const getRoleById = createAsyncThunk(
  "roles/getById",
  async (roleId, { rejectWithValue }) => {
    try {
      const res = await getRoleByIdAPI(roleId);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//   Update role

export const updateRole = createAsyncThunk(
  "roles/update",
  async ({ roleId, data }, { rejectWithValue }) => {
    try {
      const res = await updateRoleAPI({ roleId, data });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

//  Delete role

export const deleteRole = createAsyncThunk(
  "roles/delete",
  async ({ roleId, hotelId }, { rejectWithValue }) => {
    try {
      const res = await deleteRoleAPI({ roleId, hotelId });

      return {
        ...res.data,
        roleId,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const roleSlice = createSlice({
  name: "roles",
  initialState: {
    roles: [],
    selectedRole: null,

    loading: false,
    error: null,

    listLoading: false,
    listError: null,
    listSuccess: false,

    createLoading: false,
    createError: null,
    createSuccess: false,

    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false,

    pagination: {
      page: 1,
      limit: 20,
      total: 0,
      pages: 1,
    },
  },
  reducers: {
    clearSelectedRole: (state) => {
      state.selectedRole = null;
    },
    resetRoleState: () => ({
      roles: [],
      selectedRole: null,
      loading: false,
      error: null,
    }),
    clearCreateRoleState: (state) => {
      state.createLoading = false;
      state.createError = null;
      state.createSuccess = false;
    },
    clearDeleteRoleState: (state) => {
      state.deleteLoading = false;
      state.deleteError = null;
      state.deleteSuccess = false;
    },
    clearUpdateRoleState: (state) => {
      state.updateLoading = false;
      state.updateError = null;
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Get all roles
      .addCase(getRoles.pending, (state) => {
        state.listLoading = true;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.listLoading = false;
        state.listError = null;
        state.listSuccess = true;
        state.roles = action.payload.data.roles;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(getRoles.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload;
      })

      // Get role by ID
      .addCase(getRoleById.fulfilled, (state, action) => {
        state.selectedRole = action.payload;
      })

      // Create role
      .addCase(createRole.pending, (state) => {
        state.createLoading = true;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createSuccess = true;
        state.createError = null;
        state.roles.push(action.payload.data.role);
      })
      .addCase(createRole.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload;
      })

      // Update role
      .addCase(updateRole.pending, (state) => {
        state.updateLoading = true;
      })

      .addCase(updateRole.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        state.updateError = null;
        // const updatedRole = action.payload.data.role;
        // state.roles = state.roles.map((role) =>
        //   role._id === updatedRole._id ? updatedRole : role
        // );
        state.selectedRole = action.payload;
      })

      .addCase(updateRole.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = false;
        state.updateError = action.payload;
      })

      // Delete role

      .addCase(deleteRole.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
        state.deleteError = null;
        state.roles = state.roles.filter((role) => role._id !== action.payload.roleId);
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = false;
        state.deleteError = action.payload;
      });
  },
});

export const {
  clearSelectedRole,
  resetRoleState,
  clearCreateRoleState,
  clearDeleteRoleState,
  clearUpdateRoleState,
} = roleSlice.actions;
export default roleSlice.reducer;
